import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state() {
    return {
      ticketList: [],
      chargeTicketList: [],
    };
  },
  mutations,
  actions,
  getters,
  namespaced: true,
};
